<template>
    <div class="home">
        <page1 ref="p1" />
        <page2 ref="p2" />
        <page3 ref="p3" />
        <page4 ref="p4" />

    </div>
</template>

<script>

    import Page1 from './slot/Page1';
    import Page2 from './slot/Page2';
    import Page3 from './slot/Page3';
    import Page4 from './slot/Page4';



    export default {
        name: 'Home_CN',
        components: {
            Page1,Page2,Page3,Page4

        },
        metaInfo: {
            title: '大功率铁氧体磁芯|大功率磁芯|软磁铁氧体磁芯|锰锌铁氧体磁芯|南京恒创磁电有限公司 - Powered by MeCMS', // set a title
            meta: [{
                // 设置meta信息
                name: '大功率铁氧体磁芯|大功率磁芯|软磁铁氧体磁芯|锰锌铁氧体磁芯|大尺寸磁芯|X光磁芯|高压变压器磁芯|微波铁氧体',
                content: '大功率磁芯,南京恒创磁电专业生产各种高品质大磁芯，大功率铁氧体磁芯，软磁铁氧体磁芯，锰锌铁氧体磁芯，大尺寸磁芯，X光磁芯，高压变压器磁芯，电话:18913981759'
            }]
        },

        beforeRouteLeave(){
            this.$refs.p2.DestroyListener()
            this.$refs.p3.DestroyListener()
            this.$refs.p4.DestroyListener()

        },



    }
</script>
<style scoped>
    .home{
        padding: 0;
        margin: 0;
        overflow-y: hidden;
        background-image: url("../assets/page2.jpg");
        background-attachment: fixed;
    }
    .home::-webkit-scrollbar{
        display: none;
    }
</style>